module.exports = __webpack_public_path__ + "img/test2.b78538cf.png";